<template>
    <div ref="wrapper" class="app-images-hover-slider w-full">
        <div :style="styles" class="mx-auto">
            <ClientOnly>
                <template #default>
                    <ImgComparisonSlider :class="imgClass" hover class="outline-none w-full">
                        <figure slot="first" class="before">
                            <NuxtImg
                                :src="item.before.src"
                                :alt="item.before.alt"
                                :id="item.before.id"
                                class="mx-auto"
                                :class="imgClass"
                                :provider="provider"
                                loading="lazy"
                                placeholder
                                @load="$emit('load:image-before')"
                            />
                            <slot name="before-badge" />
                        </figure>

                        <figure slot="second" class="after">
                            <NuxtImg
                                :src="item.after.src"
                                :alt="item.after.alt"
                                :id="item.after.id"
                                class="mx-auto"
                                :class="imgClass"
                                :provider="provider"
                                loading="lazy"
                                placeholder
                                @load="$emit('load:image-after')"
                            />
                            <slot name="after-badge" />
                        </figure>

                        <svg
                            slot="handle"
                            width="32"
                            height="32"
                            viewBox="0 0 40 40"
                            class="backdrop-blur-sm rounded-full"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g filter="url(#filter0_b_2980_29620)">
                                <rect
                                    class="!backdrop-blur-xl"
                                    width="40"
                                    height="40"
                                    rx="20"
                                    fill="white"
                                    fill-opacity="0.6"
                                />
                                <g clip-path="url(#clip0_2980_29620)">
                                    <path
                                        d="M20 12V28"
                                        stroke="#333336"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M16 16L12 20L16 24"
                                        stroke="#333336"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M24 24L28 20L24 16"
                                        stroke="#333336"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </g>
                            </g>
                            <defs>
                                <filter
                                    id="filter0_b_2980_29620"
                                    x="-16"
                                    y="-16"
                                    width="72"
                                    height="72"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="8" />
                                    <feComposite
                                        in2="SourceAlpha"
                                        operator="in"
                                        result="effect1_backgroundBlur_2980_29620"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_backgroundBlur_2980_29620"
                                        result="shape"
                                    />
                                </filter>
                                <clipPath id="clip0_2980_29620">
                                    <rect width="24" height="24" fill="white" transform="translate(8 8)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </ImgComparisonSlider>
                </template>
                <template #fallback>
                    <AppSkeleton v-if="imgClass" :custom-size="customSize" type="square" :class="imgClass" />
                </template>
            </ClientOnly>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IImage } from "~/types/global/global.type";
import AppSkeleton from "../../../components/layout/app-skeleton/AppSkeleton.vue";
interface Props {
    item: {
        after: IImage;
        before: IImage;
    };
    styles?: string;
    imgClass?: string;
    provider?: string;
    loading?: any;
    customSize?: string;
}

defineProps<Props>();

//  * refs
const wrapper = ref<HTMLDivElement>();
</script>
